















































import VueOptions from '@utils/VueOptions'
import Modal from '@/components/Modal'
import RequestButton from '@/components/RequestButton'

settings = 
  name: 'Trigger'
  vue:
    components: { Modal, RequestButton }
    props: ['name', 'icon', 'modalOptions', 'resource', 'payload']

    data: ->
      triggerModal:
        show: false
        data: null

    mounted: ->
      @updatedData()

    methods:
      promptToTrigger: ->
        @triggerModal.show = true

      hiTrigger: ->
        await @resource.component.triggerResource @resource.key, @resource.triggerName, @triggerModal.data
        @triggerModal.show = false

      updatedData: ->
        @triggerModal.data = @payload

    watch:
      payload: ->
        @updatedData()

export default VueOptions.vue settings
